'use client';

import Tippy from '@tippyjs/react';
import { InformationCircleIcon } from '@heroicons/react/24/outline';

import UiUtils from '@utils/ui';

import 'tippy.js/dist/tippy.css';

export default function InfoTooltip({ content, position }) {
    const tooltipContent = UiUtils.linkify(content);
    return (
        <>
        {tooltipContent && tooltipContent !== "" && (typeof window !== "undefined") ? (
            <Tippy
                content={<div dangerouslySetInnerHTML={{__html: tooltipContent}}/>}
                className="font-vg-book text-base leading-130 py-0.5 px-4"
                placement={position ? position : "top"}
                interactive={UiUtils.containsAnchor(tooltipContent)}
                appendTo={document.body}
            >
                <InformationCircleIcon className="w-6 h-6 text-black" tabIndex="0" aria-label={content}/>
            </Tippy>
        ) : (
            <InformationCircleIcon className="w-6 h-6 text-grey02" tabIndex="0" aria-label="No tooltip info to show"/>
        )} 
        </>
    );
}
